import { useMemo } from "react";

import { typedQueryClient } from "hooks";
import { threeDepartmentQueryKeys } from "modules/ThreeDepartmentDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { Appointment } from "models";

export const useThreeDepartmentListeners = () => {
  return useMemo(() => {
    const appointmentListeners: WebSocketMessageListener<Appointment>[] = [
      {
        model: "Appointment",
        action: "upsert",
        callback: ({ data }) => {
          const list = typedQueryClient.getQueryData(threeDepartmentQueryKeys.list);
          if (!list?.items) return;

          const idx = list.items.findIndex(a => a.id === data.id);
          if (idx < 0) return;

          typedQueryClient.setQueryData(threeDepartmentQueryKeys.list, {
            ...list,
            items: list.items.with(idx, { ...list.items[idx], ...data })
          });
        }
      }
    ];

    return appointmentListeners;
  }, []);
};
